import React, { useState } from 'react';
import { Button, TextField, Typography, Box, InputAdornment, IconButton } from '@mui/material';
import { FaEye, FaEyeSlash } from 'react-icons/fa6';
import { Link as RouterLink } from 'react-router-dom';
import { resetCustomerPassword } from '../../helpers/httpRequests/passwordReset';

export default function NewPasswordStep({ token, onBack }) {
    const [password, setPassword] = useState('');
    const [repeat, setRepeat] = useState('');
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (password.length < 8) {
            setError('A senha deve ter ao menos 8 caracteres.');
            return;
        }
        if (password !== repeat) {
            setError('As senhas não coincidem.');
            return;
        }
        setLoading(true);
        try {
            const res = await resetCustomerPassword(token, password);
            if (res?.error) {
                setError(res.message || 'Não foi possível redefinir a senha. Tente novamente.');
            } else {
                setSuccess(true);
            }
        } catch (err) {
            setError('Erro de conexão. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <Box textAlign="center">
                <Typography color="success.main" mb={3}>
                    Senha redefinida com sucesso!
                </Typography>
                <Button component={RouterLink} to="/login" variant="contained" color="secondary">
                    Ir para o login
                </Button>
            </Box>
        );
    }

    const showToggle = (
        <InputAdornment position="end">
            <IconButton
                onClick={() => setShow((s) => !s)}
                aria-label={show ? 'Ocultar senha' : 'Mostrar senha'}
                edge="end"
            >
                {show ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
            </IconButton>
        </InputAdornment>
    );

    return (
        <form onSubmit={handleSubmit}>
            <Typography mb={2}>Digite sua nova senha (mínimo 8 caracteres):</Typography>
            <TextField
                label="Nova senha"
                type={show ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                fullWidth
                required
                margin="normal"
                InputProps={{ endAdornment: showToggle }}
            />
            <TextField
                label="Repita a nova senha"
                type={show ? 'text' : 'password'}
                value={repeat}
                onChange={e => setRepeat(e.target.value)}
                fullWidth
                required
                margin="normal"
            />
            {error && <Typography color="error" mt={1}>{error}</Typography>}
            <Box display="flex" gap={2} mt={2}>
                <Button onClick={onBack} variant="outlined" color="primary" fullWidth>
                    Voltar
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    color="secondary"
                    fullWidth
                    disabled={loading}
                >
                    {loading ? 'Salvando...' : 'Redefinir senha'}
                </Button>
            </Box>
        </form>
    );
}
